import React, {
    createContext,
    FC,
    PropsWithChildren,
    SetStateAction,
    useCallback,
    useContext,
    useMemo,
    useState,
} from "react";
import {useIdleTimer} from "react-idle-timer";
import {LanguageContext} from "./LanguageContext";

interface IIdleContext {
    setAllowedIdleTime: SetStateAction<any>;
}

export const IdleContext = createContext<IIdleContext>({} as any);
export const IdleContextEntry: FC<PropsWithChildren> = ({children}) => {
    const [allowedIdleTime, setAllowedIdleTime] = useState();
    const {moment} = useContext(LanguageContext);

    const ms = useMemo(
        () => moment.duration(allowedIdleTime).asMilliseconds(),
        [allowedIdleTime],
    );

    const {} = useIdleTimer({
        timeout: !!allowedIdleTime ? ms : undefined,
        onIdle: () => {
            if (allowedIdleTime) {
                if (ms > 0) {
                    window.localStorage.clear();
                    deleteAllCookies();
                    window.location.href = "/";
                }
            }
        },
        debounce: 500,
    });

    const deleteAllCookies = useCallback(() => {
        const cookies = document.cookie.split(";");

        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i];
            const eqPos = cookie.indexOf("=");
            const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
        }
    }, []);

    return (
        <IdleContext.Provider value={{setAllowedIdleTime}}>
            {children}
        </IdleContext.Provider>
    );
};
